/**
 * R&P Manager — thin wrapper over the shared AgentChatPanel.
 * All chat behavior lives in src/components/agent-chat/; this file only
 * supplies the research-proposal tool configuration.
 */
import { AgentChatPanel, type AgentChatToolConfig } from '@/components/agent-chat/AgentChatPanel';

const CONFIG: AgentChatToolConfig = {
	tool: 'research-proposal',
	title: (eventName) => `${eventName} — R&P Manager`,
	headerDescription: 'Research venues, review proposals, and build the client proposal in plain language.',
	backLabel: 'Back to Research & Proposal',
	composerPlaceholder: 'Message the R&P Manager…',
	agentDisplayName: 'R&P Manager',
	splitStorageKey: 'rp-agent-split',
	emptyStateHint: <>Ask about this event — for example &ldquo;Where do we stand?&rdquo;, &ldquo;Review the pending proposals&rdquo;, or drop a rates sheet to prefill budgets.</>,
	dropLabel: 'Drop rates sheets, briefs, or images here',
	boardPlaceholder: 'The agent keeps its live status board here: research progress, proposals awaiting decisions, and what was just finished.',
};

export function RPAgentPanel({ eventId, onClose }: { eventId: string; onClose: () => void }) {
	return <AgentChatPanel eventId={eventId} onClose={onClose} config={CONFIG} />;
}
